import Component from '../../../lib/component';
import template from './approval-opinion.html'
// import Mediator from "../../../lib/mediator";
import '../../../assets/scss/workflow/workflow-base.scss';
import './approval-opinion.scss';
import {PMAPI, PMENUM} from '../../../lib/postmsg'
import AttachmentControl from "../../form/attachment-control/attachment-control";
import msgbox from '../../../lib/msgbox';
import EditorControl from '../../form/editor-control/editor';

let config = {
    template: template,
    data: {
        // css: css.replace(/(\n)/g, ''),
        comment:'',
        fileList: [],
        appRejStart: false,
        approvalRejToAny: false,
        opinionTemplateOpen: false,
        is_open_template: true,
        opin_data: '',
        show_alert:false,
    },
    binds:[
        {
            event: 'click',
            selector: '.J_sure',
            callback: function (event) {
                this.actions.approvalConfirm();
            }
        },
        {
            event:'click',
            selector:'.J_cancel',
            callback:function (event) {
                if(!this.data.opinionTemplateOpen) {
                    PMAPI.sendToParent({
                        type: '1',
                        key: window.config.key,
                        data: {
                            determine: false,
                        }
                    })
                }
            }
        },{
            event:'click',
            selector:'.open-template',
            callback:function () {
                $(window.frameElement).prev().find('.ui-dialog-titlebar-close').attr('disabled', true);
                this.data.opinionTemplateOpen = true;
                if(this.data.is_open_template) {
                    this.data.is_open_template = false;
                    PMAPI.openDialogByIframe(
                        '/iframe/approvalOpinionTemplate/',
                        {
                            width: 340,
                            height: 530,
                            modal: false,
                            definedPosition: true,
                            maxable: false,
                            left: $(window.frameElement)[0].offsetParent.offsetLeft + 541,
                            title: '意见模板',
                        }).then(data => {
                        this.data.is_open_template = true;
                        this.data.opinionTemplateOpen = false;
                        $(window.frameElement).prev().find('.ui-dialog-titlebar-close').attr('disabled', false);
                        if (data && typeof data === 'string' && data !== '') {
                            this.el.find('.editor p').html(data.toString());
                        }
                        this.el.find('.J_sure').focus();
                    })
                }
            }
        },{
            event: 'click',
            selector: '.user-defined-close',
            callback: function () {
                console.log('test');
            }
        }
    ],
    actions:{
        determine(){
            let str = '';
            this.el.find('.editor p').each(function () {
                str += $(this).html();
            });
            this.data.comment = str
        },
        afterGetMsg() {
            if (this.data.appRejStart || this.data.approvalRejToAny) {
                this.el.find('.skip-node').show();
            }
            let json = {
                value: [],
                dinput_type: '9',
            };
            let changeValue = (res) => {
                this.data.fileList = res.value;
            };
            let changeValueEdit = (res) => {
                this.data.comment = res.value;
            };
            let attachmentControl = new AttachmentControl({data: json, events: {changeValue: changeValue}});
            this.append(attachmentControl, this.el.find('.workflow-attachment-box'));
            this.data.attachmentControl = attachmentControl;
            this.data.editorControl = new EditorControl({
                data: {value: '', isApproval: true},
                events: {changeValue: changeValueEdit}
            });
            this.append(this.data.editorControl, this.el.find('.approve-textarea'));
        },
        approvalConfirm(){
            let skipNode = this.el.find('[name="skipNode"]:checked').val();
            let attachmentQueueItemComps = this.data.attachmentControl.data['attachmentQueueItemComps'];
            let uploadingState;
            for(let k in Array.of(attachmentQueueItemComps) ){
                for(let key in Array.of(attachmentQueueItemComps)[k]){
                    uploadingState=Array.of(attachmentQueueItemComps)[k][key]['data']['_controlItem']['uploadingState']
                }
            }
            if(uploadingState && uploadingState == 'on'){
                msgbox.alert('上传未完成');
            }else{
                this.actions.determine();
                if(!this.data.opinionTemplateOpen) {
                    if(this.data.comment==='<br>'){
                        this.data.comment='';
                    }
                    PMAPI.sendToParent({
                        type: '1',
                        key: window.config.key,
                        data: {
                            determine:true,
                            key: this.key,
                            comment: this.data.comment,
                            attachment: this.data.fileList,
                            skipNode: skipNode
                        }
                    })
                }
            }
        }
    },
    afterRender(){
        PMAPI.getIframeParams(window.config.key).then((res) => {
            if(res.data.show_alert){
                msgbox.alert('注意：请确保每一条数据准确性，审批通过即会发送至招行系统！');
            }
            this.data.approvalRejToAny = res.data.approvalRejToAny;
            this.data.appRejStart = res.data.appRejStart;
            this.actions.afterGetMsg();
            this.data.opin_data = res.data.opin_data;
            this.data.opin_data = this.data.opin_data && this.data.opin_data.replace(/<.*?>/ig,"");
            if(this.data.opin_data !== '' && this.data.opin_data!=undefined){
                this.data.editorControl.wangEditor.txt.html(`<p>${this.data.opin_data}</p>`);
            }

        });
        // PMAPI.subscribe(PMENUM.opinion_template_edit, (data) => {
        //     if(data.isEdit) {
        //         this.data.opinionTemplateOpen = true;
        //     } else if(!data.isEdit) {
        //         this.data.opinionTemplateOpen = false;
        //     }
        // });

        window.addEventListener('keypress', (event) => {
            if(event.keyCode === 13 && event.target.className !== 'w-e-text'){
                this.actions.approvalConfirm();
            }
        })
    },
    beforeDestory(){
        this.data.style.remove();
    },
};

let approvalOpinion = Component.extend(config);
export default approvalOpinion


// WEBPACK FOOTER //
// app/components/workflow/approval-opinion/approval-opinion.js